export default {
  PER_PAGE: 20,
  MAX_PER_PAGE: 999,
};
